import React from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

interface Props {
  serviceId: number;
  serviceName?: string;
  onApply?: () => void;
}

const AppliedInternshipDSP: React.FC<Props> = ({ serviceName = "Applied Internship", onApply }) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  const handleNavigateBack = () => {
navigate(-1);
  };
  return (
    <section className="bg-white pt-2 p-4 sm:pb-6 px-3 sm:px-4">
      <div className="max-w-4xl mx-auto m-10 space-y-4">
        <div>
          <p className="text-gray-700 text-sm sm:text-sm">
            A structured internship designed to enhance technical and professional skills through On-the-Job Training (OJT), Proof-of-Concept (POC) projects, or mini assignments under expert supervision. The program bridges academic learning with real-world industry exposure of IT requirements (Software, VLSI and Business Functions including Human Resource, Recruiters, Finance & Accounting, and Corporate Law).
          </p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-lg p-4 border border-blue-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Program Mode</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <span>Offline only for hands-on learning and mentoring</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <span>Conducted by industry professionals and consultants</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-4 border border-green-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Duration</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span>Individual: 12 weeks</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span>Group: 2–6 weeks (based on project scope & availability)</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-4 border border-purple-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Intern Categories</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
              <span>Interns (I): Individuals at 7hills Office, Bangalore</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
              <span>Interns (B): Institutional batches (25–50 students) at their campus</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-lg p-4 border border-yellow-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Key Benefits</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
              <span>Real-world technical project exposure</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
              <span>Continuous mentoring and progress reviews</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
              <span>Personalized feedback and growth tracking</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
              <span>Practical application of academic concepts</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-lg p-4 border border-red-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Financials</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
              <span>Program is fee-based.</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
              <span>Group and institutional tie-ups qualify for discounts based on engagement scope and duration.</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-lg p-4 border border-cyan-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Certification</h2>
          <p className="text-gray-700">
            Participants receive a Certificate of Completion upon meeting all evaluation and project requirements.
          </p>
        </div>

        <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-lg p-4 border border-slate-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Program Deliverables</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <span>Orientation – Overview of program, structure, and goals</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <span>Training Modules – Hands-on sessions on domain tools & methods</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <span>Assignments, POC, Mini Project Development – Small-scale project aligned with skill area</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <span>Mentoring & Review – Periodic feedback and progress tracking</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <span>Final Presentation – Project demo with documentation</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <span>Feedback Report – Summary of strengths and improvement areas</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <span>Certification – Upon successful completion</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-lime-50 to-green-50 rounded-lg p-4 border border-lime-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Evaluation Parameters</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
              <span>Attendance & Engagement</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
              <span>Technical Understanding</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
              <span>Assignments, Proof-Of-Concept (POC) and/or Mini Project Quality</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
              <span>Problem-Solving & Collaboration</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
              <span>Communication & Documentation</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
              <span>Final Presentation</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-lg p-4 border border-indigo-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Engagement Flow</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <span>Register – Online or institutional request</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <span>Screening – Eligibility check & confirmation</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <span>Batch Allocation – Based on domain & mentor availability</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <span>Onboarding – Orientation and resource access</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <span>Training & Project – OJT, POC, mentoring, reviews</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <span>Evaluation & Certification – Final presentation & report delivery</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-4 border border-amber-200">
          <h2 className="text-sm font-semibold text-gray-900 mb-3">Terms & Conditions</h2>
          <ul className="space-y-2 text-gray-700">
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
              <span>Eligibility: Relevant academic/professional background required</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
              <span>IP Rights: Project outcomes owned by 7hills unless agreed otherwise</span>
            </li>
            <li className="flex gap-2">
              <ChevronRightIcon className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
              <span>Confidentiality: Protection of company data required</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AppliedInternshipDSP;
